import Test from "../";

const routes = [
    {
        name: "TestList",
        path: "/testlist",
        component: Test.TestList,
    },
    {
        name: "TestTabsScroll",
        path: "/testtabscroll",
        component: Test.TestTabsScroll,
    },
    {
        name: "TestTinyMce",
        path: "/testtinymce",
        component: Test.TestTinyMce,
    },
];

export default routes;
